import { Injectable } from '@angular/core';
import { CatalogApiService } from '@core/api/services/catalog-api.service';
import { Country } from '@shared/models/catalog.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  constructor(private readonly catalogApi: CatalogApiService) {}

  getCountries(): Observable<Country[]> {
    return this.catalogApi.getCountries() as unknown as Observable<Country[]>;
  }
}
